export async function wordPressRequest(method = "POST", url = "", data, contentType = 'application/x-www-form-urlencoded') {
	
	let headers = {
		"Content-Type"  : contentType,
		"Cache-Control" : "no-cache"
	}

	//Not setting a content-type header allows the browser to decide what it should be
	if(contentType === null){
		delete headers['Content-Type']
	}
	
	// Default options are marked with *
	const response = await fetch(url, {
		method: method, // *GET, POST, PUT, DELETE, etc.
		credentials: "same-origin", // include, *same-origin, omit
		headers: headers,
		body: data, // body data type must match "Content-Type" header
	});

	return response.json(); // parses JSON response into native JavaScript objects
}
